module.exports = __webpack_public_path__ + "static/media/footer-tree.23d12d42.png";